import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe706884"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer mt-5 p-2 d-flex align-items-center text-center justify-content-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "author" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "Developed by: Vinicius Spanol")
], -1))
const _hoisted_3 = { class: "socials" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = ["href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const icons = [
  {
    name: 'Github', icon: 'bi-github', link: 'https://www.facebook.com/code_spanol'
  },
  {
    name: 'Linkedin', icon: 'bi-linkedin', link: 'https://www.linkedin.com/in/vinicius-spanol/'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(icons, (icon) => {
          return _createElementVNode("a", {
            class: "icon",
            key: icon.name,
            href: icon.link,
            target: "_blank"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(icon.icon)
            }, null, 2)
          ], 8, _hoisted_5)
        }), 64))
      ])
    ])
  ]))
}
}

})